module.exports = {"data":{"site":{"siteMetadata":{"title":"北京青色麦田科技有限公司"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 143
// module chunks = 60335399758886 114276838955818